import * as React from 'react';
const SvgShare = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M5.75 18.583q-.562 0-.948-.388a1.3 1.3 0 0 1-.385-.951V8.757q0-.564.388-.952.39-.388.951-.388h1.59a.526.526 0 0 1 .542.537.53.53 0 0 1-.156.387.52.52 0 0 1-.386.16h-1.59a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.176v8.487q0 .096.08.176t.176.08h8.487a.25.25 0 0 0 .177-.08.24.24 0 0 0 .08-.176V8.757a.24.24 0 0 0-.08-.177.25.25 0 0 0-.177-.08h-1.59a.527.527 0 0 1-.54-.537q-.001-.23.155-.388a.52.52 0 0 1 .386-.158h1.59q.562 0 .95.388.39.389.39.952v8.487q0 .563-.39.95-.388.39-.952.39zM9.458 3.787 8.434 4.81a.54.54 0 0 1-.779.003.52.52 0 0 1-.167-.387.55.55 0 0 1 .174-.384l1.876-1.876a.64.64 0 0 1 .466-.202.62.62 0 0 1 .46.205l1.87 1.87q.174.173.178.377a.5.5 0 0 1-.167.376.57.57 0 0 1-.397.174.5.5 0 0 1-.38-.174l-1.027-1.006v8.463a.526.526 0 0 1-.537.542.53.53 0 0 1-.387-.156.52.52 0 0 1-.159-.386z'
            />
        </g>
    </svg>
);
export default SvgShare;
